import pdModalTemplateFn from '@/js/App/PdModal/pdModalTemplateFn'
import registerContentLoadersFn from '@/js/App/PdModal/registerContentLoadersFn'
import { Spinner } from '@/js/App/Spinner'
import PdModal from '@peckadesign/pd-modal'

export const modal = new PdModal({
	className: 'prose',
	spinner: Spinner({}),
	template: pdModalTemplateFn
})

registerContentLoadersFn(modal)
